import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@auth/guard/auth.guard';
import { OwnerGuard } from '@auth/guard/owner.guard';
import { TenantGuard } from '@auth/guard/tenant.guard';
import { AdminGuard } from '@auth/guard/admin.guard';
import { createConnectedGuard } from './newapp/core/guards/connected.guard';
import { notConnectedGuard } from './newapp/core/guards/not-connected.guard';

const routes: Routes = [
  {
    path: '404-not-found',
    loadChildren: () => import('./newapp/pages/not-found/not-found.module').then((m) => m.NotFoundPageModule),
    data: { pageClass: 'new_design' }
  },
  {
    path: 'auth',
    loadChildren: () => import('./newapp/pages/auth/auth.module').then((m) => m.AuthPageModule),
    data: { pageClass: 'new_design' },
    canActivate: [notConnectedGuard]
  },
  {
    path: 'wizard',
    loadChildren: () => import('./newapp/pages/wizard/wizard.module').then((m) => m.WizardPageModule),
    data: { pageClass: 'new_design' },
    canActivate: [createConnectedGuard()]
  },
  {
    path: 'payment-invoice/:paymentLinkId',
    loadChildren: () => import('./newapp/pages/payment-invoice/payment-invoice.module').then((m) => m.PaymentInvoicePageModule),
    data: { pageClass: 'new_design' }
  },
  {
    path: 'payment-link/:paymentLinkId',
    loadChildren: () => import('./newapp/pages/payment-link/payment-link.module').then((m) => m.PaymentLinkPageModule),
    data: { pageClass: 'new_design' }
  },
  {
    path: 'smily/:ref/redirect',
    loadChildren: () => import('./newapp/pages/smily-redirect/smily-redirect.module').then((m) => m.SmilyRedirectPageModule),
    data: { pageClass: 'new_design' }
  },

  {
    path: 'owner',
    loadChildren: () => import('./owner/owner.module').then((m) => m.OwnerModule),
    canActivate: [AuthGuard, OwnerGuard],
    data: { pageClass: 'deprecated_design' }
  },
  {
    path: 'user',
    loadChildren: () => import('./user/user.module').then((m) => m.UserModule),
    canActivate: [AuthGuard, TenantGuard],
    data: { pageClass: 'deprecated_design' }
  },
  {
    path: 'admin',
    loadChildren: () => import('./admin/admin.module').then((m) => m.AdminModule),
    canActivate: [AuthGuard, AdminGuard],
    data: { pageClass: 'deprecated_design' }
  },

  {
    path: 'api-money-callback/:result',
    loadChildren: () => import('./newapp/pages/api-money-callback/api-money-callback.module').then((m) => m.ApiMoneyCallbackPageModule),
    data: { pageClass: 'new_design' }
  },
  {
    path: '',
    loadChildren: () => import('./newapp/pages/dispatch/dispatch.module').then((m) => m.DispatchPageModule),
    data: { pageClass: 'new_design' }
  },
  {
    path: 'integrated/:paymentId/:token',
    loadChildren: () => import('./newapp/pages/tunnel-payment/tunnel-payment.module').then((m) => m.TunnelPaymentPageModule),
    data: { pageClass: 'new_design' }
  },
  {
    path: ':paymentId',
    loadChildren: () => import('./newapp/pages/payment/payment.module').then((m) => m.PaymentPageModule),
    data: { pageClass: 'new_design' }
  },
  {
    path: '**',
    redirectTo: '/404-not-found',
    pathMatch: 'full',
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, onSameUrlNavigation: 'reload' })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
